module.exports = __webpack_public_path__ + "static/img/加入我们-社会招聘.1d0d159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/加入我们-社会招聘.png
// module id = 646
// module chunks = 1